import React from 'react';
import Eleventhgrade_k11 from './eleventhgrade_k11';
import Eleventhgrade_k11_subjects from './eleventhgrade_k11_subjects';
const Eleventhgrade_k11math = () => {
  return (
    <div>
      <Eleventhgrade_k11 />
    <Eleventhgrade_k11_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Math section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Eleventhgrade_k11math;